// extracted by mini-css-extract-plugin
export var button = "_kn-0";
export var donut = "_kn-1";
export var donutFill = "_kn-3";
export var donutTrack = "_kn-2";